module.exports = __webpack_public_path__ + "static/media/mustard.9e5ab685.svg";